import React from "react";
import "./About.scss";
const About = () => {
  return (
    <div className="about" id="about">
      <div className="left">
        <div className="imgContainer">
          <img src="assets/man1.png" alt="" />
        </div>
        >
      </div>
      <div className="right">
        <h2>About Me</h2>
        <div className="wrapper">
          <p>
            I'm a Web and Android Programmer. Proficient in Full Stack
            Development(web) and full stack development(android). Well-versed in
            numerous programming languages & libraries including HTML5,
            CSS3,Bootsrap, ReactBootsrap, Material UI, JavaScript(ES6),
            ReactJS,React-Native, NodeJS, MongoDB, SQL, MySQL, Python, Java,
            ,C++, C,Ros, FORTRAN, MATLAB etc. I'm interested in developing web
            ,android and ROS projects.🤖
          </p>
        </div>
        <a
          className="btn"
          href="https://drive.google.com/file/d/1oyuyKRD5rPu4-uho0yh0etLZfonCodi-/view"
          target="_blank"
          rel="noreferrer"
        >
          Resume
        </a>
        {/* <a className="wrapper btn"
          href="">
          Education
        </a> */}
        <a href="#education" className=" btn">
          <img src="#education" alt="" />
          Education
        </a>
      </div>
    </div>
  );
};

export default About;
